export const enToHeActivityField = {
    "PackingFoodDonationGear": "אריזת מזון וציוד לתרומה",
    "DistributingFoodDonationGear": "חלוקת מזון וציוד לתרומה",
    "TransportEquipmentMedicinesPatients": "שינוע ציוד, תרופות וחולים",
    "FacilitationInstruction": "הפעלה והדרכה",
    "Environment": "איכות הסביבה",
    "Animals": "בעלי חיים",
    "GardeningPainting": "גינון וצביעה",
    "Other": "אחר",
    "GoodDeedsDay": "אירוע השיא של יום מעשים טובים",
    "RemoteVolunteering": "התנדבות מהבית",
    "DIY": "עשו זאת בעצמכם",
    "MorningHospitality": "אירוע בוקר",
    "CreateRenovateGarden": "הקמת/חידוש גינה",
    "WallMural": "ציור קיר",
    "Indoor": "פנימי",
    "RenovationPainting": "חידוש וצביעה",
};
